import { Spin } from 'antd';

function Loading({ isLoading }: { isLoading: boolean }) {
  if (!isLoading) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      ></div>
      <Spin
        // spinning={true}
        style={{ padding: '10px 50px' }}
        size="large"
        tip="Loading..."
      ></Spin>
    </div>
  );
}

export default Loading;
